// Utilidades para turnos de imágenes, adaptadas de nuevoTurnoUtils.js
import dayjs from "dayjs";

export function ordenarPrestadoresPorProximoTurno(prestadores) {
  return prestadores.slice().sort((a, b) => {
    if (a.proximoTurnoFecha && b.proximoTurnoFecha) {
      const fechaA = dayjs(a.proximoTurnoFecha);
      const fechaB = dayjs(b.proximoTurnoFecha);
      if (fechaA.isBefore(fechaB)) return -1;
      if (fechaA.isAfter(fechaB)) return 1;
      return (a.text || a.nombre || '').localeCompare(b.text || b.nombre || '');
    }
    if (a.proximoTurnoFecha && !b.proximoTurnoFecha) return -1;
    if (!a.proximoTurnoFecha && b.proximoTurnoFecha) return 1;
    return (a.text || a.nombre || '').localeCompare(b.text || b.nombre || '');
  });
}

export const verificarInasistenciasPorEstudio = (estudio, turnosPaciente) => {
  let inasistidos = 0;
  turnosPaciente.forEach((turno) => {
    if (
      (dayjs(turno.fecha).isSame(new dayjs()) &&
        dayjs(turno.hora).format("HH:mm") >=
          dayjs("0001-01-01T00:00:00").format("HH:mm")) ||
      (dayjs(turno.fecha).isAfter(new dayjs().subtract(2, "month")) &&
        dayjs(turno.fecha).isBefore(new dayjs()))
    ) {
      if (turno.estudio === estudio && turno.asistio === false) {
        inasistidos += 1;
      }
    }
  });
  return inasistidos > 1;
};

export const verificarTurnoConPrestadorPendiente = (prestador, turnosPaciente) => {
  let turnoPendiente = false;
  turnosPaciente.forEach((turno) => {
    if (
      (dayjs(turno.fecha).isSame(new dayjs()) &&
        dayjs(turno.hora).format("HH:mm") <=
          dayjs("0001-01-01T00:00:00").format("HH:mm")) ||
      (dayjs(turno.fecha).isBefore(new dayjs().add(2, "month")) &&
        dayjs(turno.fecha).isAfter(new dayjs()))
    ) {
      if (turno.prestadorCod === prestador) {
        turnoPendiente = true;
      }
    }
  });
  return turnoPendiente;
};

// Puedes agregar más utilidades según lo necesites
